module.exports = __webpack_public_path__ + "static/media/P4.f6af2dda.jpg";